import "./FirstLayer.css";

import profile from "../../Images/AboutMeImages/Headshot3.jpg"
import UofALogo from "../../Images/ReceiptApp-images/UofA-logo.png"

import { IconContext } from "react-icons/lib";
import { AiFillGithub, AiFillLinkedin } from "react-icons/ai";

const FirstLayer = () => {
  return (
    <div className="first-layer">
      {/* Homepage and introduction section */}
      <div className="container col-lg-10 col-md-10 col-sm-10 col-xs-10">
        {/* <ul className="circles">
          <li></li>
        </ul> */}
        <img className="profile-pic container-fluid" src={profile} alt=""></img>

        {/* Profile picture and heading */}
        <div className="container-fluid">
          <h1 className="profile-text">Hi, I'm Nathan</h1>
        </div>

        <div className="container-fluid">
          <h4 className="profile-intro">I study computer science at the University of Alberta and my primary interests is in Natural Language Processing (NLP) and Software Development</h4>
        </div>


        <div className="container-fluid">
          <h4 className="profile-desc">
            Outside of school and work, I enjoy lifting weights and palying basketball to stay healthy. 
            I also like relaxing at home by watching TV shows, playing video games, or playing/listening to music 
             </h4>
        </div>


        <div className="images">
          <img className="w-25" src={UofALogo} alt=""></img>
        </div>


        {/* Github and Linkedin icons */}
        <IconContext.Provider value={{ className: "shared-class", size: 42 }}>
          <a href="https://github.com/NateLapak">
            <AiFillGithub href="https://github.com/NateLapak" />
          </a>
          <a href="https://www.linkedin.com/in/nathan-lapak-a88b2118a/">
            <AiFillLinkedin />
          </a>
        </IconContext.Provider>

      </div>
    </div>
  );
};

export default FirstLayer;
